/* eslint-disable import/prefer-default-export */
import ReactGA from "react-ga";
import TagManager from "react-gtm-module";
import { G_TAG } from "../constants/env/google.constants";

export type AnalyticsEvent = {
  eventCategory: string;
  eventAction: string;
  nonInteraction?: boolean;
  value?: any;
  eventLabel?: string;
};
type analyticsOptions = {
  [key: string]: any;
};

export type googleTagEventType = {
  eventName: string;
  gtmId: string;
  isRootDataLayer?: boolean;
  properties?: {}
};

export const sendAnalyticsEvent = ({
  eventCategory,
  eventAction,
  nonInteraction = false,
  value,
  eventLabel,
}: AnalyticsEvent) => {
  const ga = ReactGA.ga();

  const options: analyticsOptions = {
    eventCategory,
    eventAction,
  };
  if (ga !== undefined) {
    if (eventLabel) {
      options[eventLabel] = eventLabel;
    }
    if (nonInteraction) {
      ga("set", "nonInteraction", true);
    }
    if (value) {
      options[value] = value;
    }
    ga("send", "event", options);
    ga("send", "pageview");
  }
};

export const sendGoogleTagEvent = ({
  eventName,
  gtmId,
  properties = {},
  isRootDataLayer = false,
}: googleTagEventType) => {
  TagManager.dataLayer({
    dataLayer: { event: eventName, ...properties },
    dataLayerName: isRootDataLayer
      ? G_TAG.ROOT_DATA_LAYER
      : G_TAG.SUBDOMAIN_DATA_LAYER,
  });
  TagManager.initialize({
    gtmId,
    dataLayerName: isRootDataLayer
      ? G_TAG.ROOT_DATA_LAYER
      : G_TAG.SUBDOMAIN_DATA_LAYER,
  });
};
